import { HandoverScaffoldData } from './handover-scaffold-data';
import { MediaData } from './media-data';
import { HandoverIdentifiedRiskData } from './handover-identified-risk-data';
import { SiteDocumentStatusEnum } from '../../enum/site-document-status.enum';
import { StaffSignatureData } from './staff-signature-data';
import { CustomerSignatureData } from './customer-signature-data';
import { HandoverHandoverSettingsData } from './handover-handover-settings-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class HandoverData {
  HandoverId: string;
  NextInspectionDate: string;
  RisksIdentified: boolean;
  HandOverType: number;
  Scaffolds: HandoverScaffoldData[];
  HandoverComments: string;
  HirePeriod: number;
  IdentifiedRiskDetails: string;
  Media: { [key: string]: MediaData };
  IdentifiedRisks: { [key: string]: HandoverIdentifiedRiskData };
  HandoverQuestionsAsked: string[];
  When: string;
  HandoverReference: string;
  Status: SiteDocumentStatusEnum;
  SiteId: string;
  CustomerId: string;
  StaffSignature: StaffSignatureData;
  CustomerSignature: CustomerSignatureData;
  HandoverHandoverSettingsData: HandoverHandoverSettingsData[];
  Deleted: boolean;
  LastModified: string;
}


